import axios from 'axios';
import urlImages from './urlImages';

const clienteAxios2 = axios.create({
    // baseURL: 'https://upload-solidare.mypruebaelemental.com/' //dev
    baseURL: urlImages
});

export default clienteAxios2;